import React from 'react';

const PublicLayout = ({ children }) => {
  return (
    <div>
      {/* No Header or Footer here */}
      {children}
    </div>
  );
};

export default PublicLayout;
